<h2 data-cy="header-alert" mat-dialog-title>{{alertData.header}}</h2>
<mat-dialog-content>
  @for (line of alertData.message.split('\n'); track line) {
    {{line}}
    <br>
    }
    @if (showCheckbox) {
      <mat-checkbox [formControl]="checkboxControl">{{ alertData.checkboxMessage }}</mat-checkbox>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button data-cy="button-alert" mat-button (click)="onButtonClick()">{{alertData.buttonText}}</button>
  </mat-dialog-actions>
